import "./AboutUs.css";

import React from "react";

const AboutUs = () => {
  return (
    <div className="about-container">
      <h1>Our History</h1>
      <p>
        Goa is a state in western India with coastlines stretching along the
        Arabian Sea. Its long history as a Portuguese colony prior to 1961 is
        evident in its preserved 17th-century churches and the area’s tropical
        spice plantations. Goa is also known for its beaches, ranging from
        popular stretches at Baga and Palolem to those in laid-back fishing
        villages such as Agonda.Goa is also known for its beaches, ranging from
        popular stretches at Baga and Palolem to those in laid-back fishing
        villages such as Agonda.
      </p>

      <h1>Our Mission</h1>
      <p>
        Goa is a state in western India with coastlines stretching along the
        Arabian Sea. Its long history as a Portuguese colony prior to 1961 is
        evident in its preserved 17th-century churches and the area’s tropical
        spice plantations. Goa is also known for its beaches, ranging from
        popular stretches at Baga.Goa is also known for its beaches, ranging
        from popular stretches at Baga.
      </p>

      <h1>Our Vision</h1>
      <p>
        Goa is a state in western India with coastlines stretching along the
        Arabian Sea. Its long history as a Portuguese colony prior to 1961 is
        evident in its preserved 17th-century churches and the area’s tropical
        spice plantations.
      </p>
    </div>
  );
};

export default AboutUs;
